export const BASE_API_URL = import.meta.env.VITE_API_BASE_URL || "";
export const APP_DISPATCH_URL = import.meta.env.VITE_APP_DISPATCH_URL || "";
export const PANDA_SCORE_URL = import.meta.env.VITE_PANDA_SCORE_URL || "";
export const SUPPORT_DEFAULT_EMAIL =
  import.meta.env.VITE_SUPPORT_DEFAULT_EMAIL || "care@fleetpanda.com";

export const LOGIN_URL = "tenant-portal/auth/login";
export const LOG_OUT_URL = "tenant-portal/auth/logout";
export const TENANT_DISPATCH_URL = "tenant-portal/auth/dispatch-tenant";
export const TENANTS_URL = "tenant-portal/tenants";
export const SETTING_URL = "tenant-portal/user/setting";
export const SWAGGER_URL = "tenant-portal/swagger";
export const FRESHDESK_TICKETS_URL = "tenant-portal/freshdesk/tickets";
export const FRESHDESK_TICKET_URL = "tenant-portal/freshdesk/ticket";
export const FRESHDESK_SUPPORT_EMAIL_URL = "tenant-portal/freshdesk/support-email";
export const SHOPIFY_ORDER_HISTORY_URL = "tenant-portal/shopify/order/history";
export const CLICKUP_TICKETS_URL = "tenant-portal/clickup/tickets";
export const CLICKUP_ANALYTICS_URL = "tenant-portal/clickup/analytics";
export const USER_INFO_URL = "tenant-portal/user/info";
export const SAVED_VIEW_URL = "tenant-portal/saved-views";

// Org Settings (core routes - no portal gate)
export const CORE_BOOTSTRAP_URL = "tenant-portal/core/bootstrap";
export const ORG_SEATS_URL = "tenant-portal/core/org/seats";
export const ORG_USERS_URL = "tenant-portal/core/org/users";
